export default __webpack_public_path__ + "static/robot-2dc85bc4ca9c0e5cdff863aa64686c4c.png";